/**
 * Action types for ATF Profile functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_ATF_PROFILE = 'GET_ATF_PROFILE';
export const GET_ATF_PROFILE_SUCCESS = 'GET_ATF_PROFILE_SUCCESS';
export const GET_ATF_PROFILE_FAIL = 'GET_VLAN_POOL_FAIL';

export const EDIT_ATF_PROFILE = 'EDIT_ATF_PROFILE';
export const EDIT_ATF_PROFILE_SUCCESS = 'EDIT_ATF_PROFILE_SUCCESS';
export const EDIT_ATF_PROFILE_FAIL = 'EDIT_ATF_PROFILE_FAIL';
export const ATF_EDIT_SUCCESS_MESSAGE = 'ATF_PROFILE_UPDATED_SUCCESSFULLY';
export const ATF_EDIT_RESET = 'ATF_EDIT_RESET';
